import { getApiUrl } from './api.config';

// API helper function matching the pattern from authApi
const apiCall = async (url: string, options: RequestInit = {}) => {
  const token = localStorage.getItem('authToken');
  const config: RequestInit = {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...(token && { 'Authorization': `Bearer ${token}` }),
      ...options.headers,
    },
  };

  const response = await fetch(url, config);
  
  if (!response.ok) {
    const contentType = response.headers.get('content-type');
    let error;
    
    if (contentType && contentType.includes('application/json')) {
      try {
        error = await response.json();
      } catch {
        error = { error: `Request failed with status ${response.status}` };
      }
    } else {
      error = { error: `Request failed with status ${response.status}` };
    }
    
    throw new Error(error.error || `Request failed with status ${response.status}`);
  }
  
  const contentType = response.headers.get('content-type');
  if (contentType && contentType.includes('application/json')) {
    return response.json();
  }
  
  return response.text();
};

export interface CreateSubscriptionRequest {
  sourceId: string;
  userEmail: string;
  planId: string;
}

export interface SubscriptionResponse {
  subscriptionId: string;
  status: string;
  message: string;
}

export interface SubscriptionStatusResponse {
  tier: string;
  status: string;
  squareCustomerId?: string;
  expiresAt?: string;
  features: string[];
  currentSubscription?: SubscriptionDetailsDto;
}

export interface SubscriptionDetailsDto {
  subscriptionId: string;
  planName: string;
  amount: number;
  currency: string;
  billingPeriod: string;
  startDate: string;
  endDate?: string;
  status: string;
}

export interface CancelSubscriptionResponse {
  success: boolean;
  message: string;
}

export const paymentsApi = {
  createSubscription: async (data: CreateSubscriptionRequest): Promise<SubscriptionResponse> => {
    const url = getApiUrl(`payments/create-subscription?userEmail=${data.userEmail}`);
    return await apiCall(url, {
      method: 'POST',
      body: JSON.stringify({
        sourceId: data.sourceId,
        userEmail: data.userEmail,  // Backend DTO expects this
        planId: data.planId
      })
    });
  },

  getSubscriptionStatus: async (userEmail: string): Promise<SubscriptionStatusResponse> => {
    const url = getApiUrl(`payments/subscription-status?userEmail=${userEmail}`);
    return await apiCall(url, {
      method: 'GET'
    });
  },

  cancelSubscription: async (userEmail: string): Promise<CancelSubscriptionResponse> => {
    const url = getApiUrl(`payments/cancel-subscription?userEmail=${userEmail}`);
    return await apiCall(url, {
      method: 'POST'
    });
  }
};